// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-blue-rgb: 74, 59, 255;
}

.header-section {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    /* izquierda - centro - derecha */
    align-items: center;
    padding: 16px 32px;
    background-color: var(--app-fondo);
    border-bottom: 1px solid var(--color-light-bg);
    margin-bottom: 30px;
    box-shadow: var(--sombra-card);
}

/* LOGO */

.logo-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    font-weight: 700;
    font-size: 1.2rem;
    color: var(--primary-blue);
    justify-self: start;
}

.logo-icon {
    font-size: 28px;
    line-height: 1;
}

.logo-text {
    font-size: 1.2rem;
    margin: 0;
    line-height: 1.1;
}

/* TÍTULO */

.header-page-title {
    font-size: 28px;
    font-weight: 600;
    color: var(--primary-blue);
    margin: 0;
    text-align: center;
    justify-self: center;
}


/* MENU */

.header-menu {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    justify-self: end;
    align-items: center;
    border-radius: 50%;
    transition: background-color 0.2s ease;
}

/* BOTÓN QUE ABRE EL MENÚ */
.header-user-menu-button {
    width: 40px;
    height: 40px;
    background: none;
    border: none;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 50%;
    transition: background-color 0.2s ease;
    padding: 0;
}

.header-user-menu-button:hover{
    background-color: rgba(var(--primary-blue-rgb), 0.15);
    /* suave */
    cursor: pointer;
}
.menu-icon {
    font-size: 26px;
    color: var(--primary-blue);
}`, "",{"version":3,"sources":["webpack://./src/components/Header/header.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,8CAA8C;IAC9C,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,SAAS;;AAET;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;AACpB;;AAEA,WAAW;;AAEX;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;IAClB,oBAAoB;AACxB;;;AAGA,SAAS;;AAET;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;;IAEf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;IAClB,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,qDAAqD;IACrD,UAAU;IACV,eAAe;AACnB;AACA;IACI,eAAe;IACf,0BAA0B;AAC9B","sourcesContent":[":root {\r\n    --primary-blue-rgb: 74, 59, 255;\r\n}\r\n\r\n.header-section {\r\n    display: grid;\r\n    grid-template-columns: 1fr auto 1fr;\r\n    /* izquierda - centro - derecha */\r\n    align-items: center;\r\n    padding: 16px 32px;\r\n    background-color: var(--app-fondo);\r\n    border-bottom: 1px solid var(--color-light-bg);\r\n    margin-bottom: 30px;\r\n    box-shadow: var(--sombra-card);\r\n}\r\n\r\n/* LOGO */\r\n\r\n.logo-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-decoration: none;\r\n    font-weight: 700;\r\n    font-size: 1.2rem;\r\n    color: var(--primary-blue);\r\n    justify-self: start;\r\n}\r\n\r\n.logo-icon {\r\n    font-size: 28px;\r\n    line-height: 1;\r\n}\r\n\r\n.logo-text {\r\n    font-size: 1.2rem;\r\n    margin: 0;\r\n    line-height: 1.1;\r\n}\r\n\r\n/* TÍTULO */\r\n\r\n.header-page-title {\r\n    font-size: 28px;\r\n    font-weight: 600;\r\n    color: var(--primary-blue);\r\n    margin: 0;\r\n    text-align: center;\r\n    justify-self: center;\r\n}\r\n\r\n\r\n/* MENU */\r\n\r\n.header-menu {\r\n    width: 40px;\r\n    height: 40px;\r\n    display: flex;\r\n    justify-content: center;\r\n    justify-self: end;\r\n    align-items: center;\r\n    border-radius: 50%;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n/* BOTÓN QUE ABRE EL MENÚ */\r\n.header-user-menu-button {\r\n    width: 40px;\r\n    height: 40px;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    border-radius: 50%;\r\n    transition: background-color 0.2s ease;\r\n    padding: 0;\r\n}\r\n\r\n.header-user-menu-button:hover{\r\n    background-color: rgba(var(--primary-blue-rgb), 0.15);\r\n    /* suave */\r\n    cursor: pointer;\r\n}\r\n.menu-icon {\r\n    font-size: 26px;\r\n    color: var(--primary-blue);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
